module.exports = __webpack_public_path__ + "static/Calibre-Semibold-d8b856473a51d7eec2a9bccf2fbea54c.woff2";